import { computed as u, createElementBlock as t, openBlock as r, createCommentVNode as i, Fragment as m, renderList as g, normalizeClass as p, createElementVNode as $, toDisplayString as _, createVNode as b, unref as n, withCtx as w, createTextVNode as N, renderSlot as l } from "vue";
import { useTracking as B } from "../../../composables/useTracking.js";
import { screenProp as P, isScreenLarge as f } from "../../../utils/utilsScreen.js";
/* empty css                               */
import C from "../../../_virtual/_plugin-vue_export-helper.js";
import S from "../../../atoms/anchor-element/anchor-element.vue.js";
const T = { class: "ds-grid ds-position-relative" }, V = {
  class: "ds-text ds-font-weight-bold ds-color-black",
  role: "none"
}, D = {
  key: 0,
  class: "ds-page-footer__social-bar"
}, F = { key: 1 }, I = {
  key: 1,
  class: "ds-grid__col ds-grid__col--12 ds-margin-top-24 ds-md-margin-top-96"
}, E = /* @__PURE__ */ Object.assign({
  name: "DsFooterPrimaryNavigation"
}, {
  __name: "footer-primary-navigation",
  props: {
    ...P,
    items: { type: Array, required: !0 }
  },
  setup(c) {
    const { getTrackingText: v, trackingDataProvided: y } = B(), s = c, k = u(() => s.screen === "small" ? 1 : s.screen === "medium" ? 2 : s.items.length + 1), h = u(() => s.items.length <= 5 ? 12 - s.items.length * 2 : 2);
    return (e, L) => (r(), t("nav", T, [
      (r(!0), t(m, null, g(c.items, (a, d) => (r(), t("ul", {
        key: `primary-navigation-item-${d}`,
        class: p([{ "ds-padding-top-48": d > k.value }, "ds-grid__col ds-grid__col--6 ds-md-grid__col--4 ds-lg-grid__col--2 ds-lg-padding-top-0"]),
        role: "menubar"
      }, [
        $("li", V, _(a.title), 1),
        (r(!0), t(m, null, g(a.links, (o) => (r(), t("li", {
          key: o.id,
          class: "ds-margin-top-12",
          role: "none"
        }, [
          b(n(S), {
            url: o.url,
            "open-in-new-window": o.openInNewWindow,
            nuxt: o.nuxt,
            "tracking-data": { "component-name": "Footer Primary Nav", text: n(v)(a, d, o), ...n(y) },
            class: "ds-button-link ds-button-link--tertiary ds-button-link--black",
            role: "menuitem"
          }, {
            default: w(() => [
              N(_(o.title), 1)
            ]),
            _: 2
          }, 1032, ["url", "open-in-new-window", "nuxt", "tracking-data"])
        ]))), 128))
      ], 2))), 128)),
      e.$slots.socialBar || e.$slots.signup ? (r(), t("div", {
        key: 0,
        class: p(["ds-grid__col ds-grid__col--12 ds-md-grid__col--4 ds-lg-grid__col--2 ds-page-footer__social-signup", `ds-lg-grid__col--${h.value}`])
      }, [
        e.$slots.socialBar ? (r(), t("div", D, [
          l(e.$slots, "socialBar", {}, void 0, !0)
        ])) : i("", !0),
        e.$slots.signup && n(f)(e.screen) ? (r(), t("div", F, [
          l(e.$slots, "signup", {}, void 0, !0)
        ])) : i("", !0)
      ], 2)) : i("", !0),
      e.$slots.signup && !n(f)(e.screen) ? (r(), t("div", I, [
        l(e.$slots, "signup", {}, void 0, !0)
      ])) : i("", !0)
    ]));
  }
}), x = /* @__PURE__ */ C(E, [["__scopeId", "data-v-b87ea9aa"]]);
export {
  x as default
};
